import { render, staticRenderFns } from "./InputFileField.vue?vue&type=template&id=b745d520&scoped=true"
import script from "./InputFileField.vue?vue&type=script&lang=js"
export * from "./InputFileField.vue?vue&type=script&lang=js"
import style0 from "./InputFileField.vue?vue&type=style&index=0&id=b745d520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b745d520",
  null
  
)

export default component.exports